module.exports = __webpack_public_path__ + "static/ABONNEMENT_12-4a6806b719e39def812e05d1b9e70898.png";